// Growth OS — Arabic names for everything «تحليل السلوك» shows. The technical
// name stays available as a tooltip only. A test checks that every event in
// the catalogue has a name here, so a new event cannot appear as raw English.

export const EVENT_AR = {
  address_submitted: 'أدخل عنوان التوصيل',
  app_backgrounded: 'خرج من التطبيق',
  ask_supplier_clicked: 'ضغط «اسأل المورّد»',
  auth_method_chosen: 'اختار طريقة الدخول',
  auth_viewed: 'فتح صفحة الدخول',
  cart_fee_nudge_clicked: 'ضغط تنبيه رسوم السلة',
  cart_item_added: 'أضاف منتجاً للسلة',
  cart_item_qty_changed: 'غيّر الكمية في السلة',
  cart_item_removed: 'حذف منتجاً من السلة',
  cart_minimum_blocked: 'وقف عند الحد الأدنى للسلة',
  cart_shipping_changed: 'غيّر الشحن في السلة',
  cart_viewed: 'فتح السلة',
  category_viewed: 'فتح تصنيفاً',
  checkout_abandoned: 'ترك الدفع',
  checkout_signin_result: 'نتيجة الدخول عند الدفع',
  checkout_started: 'بدأ الدفع',
  checkout_step_viewed: 'فتح خطوة من الدفع',
  clarity_session_linked: 'رُبطت الجلسة بتسجيل Clarity',
  home_item_clicked: 'ضغط عنصراً في الرئيسية',
  home_section_viewed: 'شاهد قسماً في الرئيسية',
  image_search_result_clicked: 'ضغط نتيجة بحث بالصورة',
  image_search_results_shown: 'ظهرت نتائج البحث بالصورة',
  image_search_started: 'بدأ بحثاً بالصورة',
  list_scrolled_depth: 'مرّر في قائمة المنتجات',
  login_completed: 'سجّل الدخول',
  order_action: 'إجراء على طلب',
  order_opened: 'فتح طلباً',
  orders_viewed: 'فتح طلباتي',
  otp_failed: 'رمز تحقق خاطئ',
  otp_requested: 'طلب رمز تحقق',
  otp_verified: 'تحقق بالرمز',
  page_hidden: 'غادر الصفحة',
  payment_method_selected: 'اختار طريقة الدفع',
  payment_returned: 'عاد من صفحة الدفع',
  payment_started: 'ذهب للدفع',
  payment_succeeded: 'دفع بنجاح',
  product_block_seen: 'شاهد قسماً في صفحة المنتج',
  product_favorited: 'أضاف منتجاً للمفضلة',
  product_image_swiped: 'قلّب صور المنتج',
  product_left: 'غادر صفحة المنتج',
  product_qty_changed: 'غيّر الكمية في صفحة المنتج',
  product_qty_table_seen: 'شاهد جدول الكميات',
  product_variant_changed: 'غيّر الخيار (لون/مقاس)',
  product_viewed: 'فتح منتجاً',
  push_opened: 'فتح إشعاراً',
  save_upsell_clicked: 'ضغط عرض التوفير',
  save_upsell_shown: 'ظهر له عرض التوفير',
  screen_viewed: 'فتح صفحة',
  search_abandoned: 'ترك البحث',
  search_refined: 'عدّل البحث',
  search_result_clicked: 'ضغط نتيجة بحث',
  search_results_shown: 'ظهرت نتائج البحث',
  search_submitted: 'بحث',
  service_attachment_added: 'أرفق ملفاً في طلب خدمة',
  service_entry_clicked: 'ضغط مدخل خدمة',
  service_fee_paid: 'دفع رسوم الطلب',
  service_fee_shown: 'ظهرت له رسوم الطلب',
  service_form_abandoned: 'ترك نموذج الخدمة',
  service_form_field_error: 'خطأ في حقل بنموذج الخدمة',
  service_form_started: 'بدأ نموذج خدمة',
  service_form_step: 'تقدّم خطوة في نموذج الخدمة',
  service_submitted: 'أرسل طلب خدمة',
  session_started: 'بدأ زيارة',
  shipping_option_selected: 'اختار طريقة شحن',
  shipping_option_viewed: 'شاهد خيارات الشحن',
  signup_completed: 'أنشأ حساباً',
};
export const eventAr = (name) => EVENT_AR[name] || name;

// Clarity's metrics: Arabic name, one line of what it means, and which of the
// fields Clarity returns carry the value (seen in the first live pull,
// 2026-11-01): counts carry subTotal + sessionsCount +
// sessionsWithMetricPercentage; ScrollDepth averageScrollDepth (%);
// EngagementTime activeTime / totalTime (seconds, per-session averages:
// 83 sessions with totalTime 76 cannot be a sum).
export const CLARITY_METRICS = [
  { key: 'RageClickCount', ar: 'نقرات غاضبة', note: 'نقر متكرر بسرعة على نفس المكان — غالباً زر لا يستجيب كما يتوقع الزائر.', kind: 'count', bad: true },
  { key: 'DeadClickCount', ar: 'نقرات ميتة', note: 'نقر على شيء لا يحدث بعده شيء — يظنه الزائر زراً أو رابطاً.', kind: 'count', bad: true },
  { key: 'QuickbackClick', ar: 'رجوع سريع', note: 'فتح صفحة ثم رجع منها خلال ثوانٍ — لم يجد ما توقعه.', kind: 'count', bad: true },
  { key: 'ExcessiveScroll', ar: 'تمرير مفرط', note: 'مرّر صعوداً ونزولاً كثيراً — يبحث عن شيء ولا يجده.', kind: 'count', bad: true },
  { key: 'ScriptErrorCount', ar: 'أخطاء في الصفحة', note: 'أخطاء برمجية ظهرت في متصفح الزائر أثناء الجلسة.', kind: 'count', bad: true },
  { key: 'ScrollDepth', ar: 'عمق التمرير', note: 'إلى أي نسبة من طول الصفحة وصل الزائر في المتوسط.', kind: 'scroll' },
  { key: 'EngagementTime', ar: 'وقت التفاعل الفعلي', note: 'الوقت الذي كان فيه الزائر يحرّك أو ينقر أو يمرّر، من وقت الجلسة كله.', kind: 'time' },
];
export const CLARITY_METRIC_AR = Object.fromEntries(CLARITY_METRICS.map((m) => [m.key, m.ar]));

export const CHANNEL_AR = {
  AiPlatform: 'منصات الذكاء الاصطناعي', OrganicSearch: 'بحث مجاني', PaidSearch: 'بحث مدفوع', Direct: 'مباشر',
  Other: 'مباشر/غير معروف', Social: 'شبكات اجتماعية', OrganicSocial: 'شبكات اجتماعية', PaidSocial: 'إعلانات اجتماعية',
  Referral: 'روابط من مواقع أخرى', Email: 'بريد إلكتروني', Display: 'إعلانات مصوّرة', Affiliate: 'شركاء', Video: 'فيديو',
};
export const DEVICE_AR = { Mobile: 'جوال', PC: 'كمبيوتر', Tablet: 'جهاز لوحي', Other: 'أخرى' };
export const OS_AR = { IOS: 'iOS', Android: 'Android', MacOSX: 'macOS', Windows: 'Windows', Linux: 'Linux', Other: 'أخرى' };

// Known sources by referrer domain or utm_source, for sentences people read.
export const SOURCE_AR = [
  [/chatgpt|openai/i, 'ChatGPT'], [/perplexity/i, 'Perplexity'], [/gemini|bard/i, 'Gemini'], [/copilot|bing/i, 'Bing / Copilot'],
  [/google/i, 'Google'], [/snapchat/i, 'Snapchat'], [/tiktok/i, 'TikTok'], [/instagram/i, 'Instagram'], [/facebook|fb\./i, 'Facebook'],
  [/(^|\.)t\.co$|twitter|x\.com/i, 'X'], [/whatsapp|wa\.me/i, 'واتساب'], [/youtube/i, 'YouTube'],
];
export const sourceName = (s) => { const v = String(s || ''); const hit = SOURCE_AR.find(([re]) => re.test(v)); return hit ? hit[1] : v; };
export const AI_SOURCE = /chatgpt|openai|perplexity|gemini|copilot|claude\.ai/i;
